import { gql } from "@apollo/client";

export default gql`
  query Vehicle($id: Int!) {
    vehicle(id: $id) {
      id
      plate
      type
      isRefrigerated
      trackerBrand
      trackerId
      speedLimitDry
      speedLimitWet
      tareWeightKg
      temperatureMax
      temperatureMin
    }
  }
`;
